import React, { useState } from "react";
import Title from "../components/common/Title";
import FilterSelector from "../components/tax-exempt/FilterSelector";
import { taxEmeptReport } from "../App";
import Server from "../api/Server";
import notify from "devextreme/ui/notify";
import TaxExemptReportTable from "../components/tax-exempt/TaxExemptReportTable";
import { LoadPanel } from "devextreme-react";

const TaxExempt = () => {
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetReport = async (e) => {
    e.preventDefault();

    let params = null;

    setIsLoading(true);

    if (taxEmeptReport.userGroupIds.length) {
      params = {
        userGroupIds: taxEmeptReport.userGroupIds.map((e) => e).toString(),
      };
    }

    try {
      const { data } = await Server.getTaxExemptReport(params);
      setIsLoading(false);
      setReportData(data.data.customers);
    } catch (err) {
      if (err.response) {
        const {
          response: { data },
        } = err;
        if (data) {
          notify(`${data.status.errorDescription}`, "error", 3000);
        } else {
          notify("Error getting reports data, please try again", "error", 3000);
        }
      } else {
        notify("Error getting reports data, please try again", "error", 3000);
      }

      setIsLoading(false);
    }
  };

  return (
    <section>
      {isLoading && <LoadPanel visible />}
      <Title pageTitle={"Tax exempt report"} />
      <FilterSelector
        formData={taxEmeptReport}
        handleGetReport={handleGetReport}
      />
      {reportData && <TaxExemptReportTable reportStore={reportData} />}
    </section>
  );
};

export default TaxExempt;
